import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { useState, useRef, useEffect } from "react";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';

function RowList2({data}) {  
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef();
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const Approve = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ approveWith: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
                window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const Decline = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ declineWith: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const Delete = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteWith: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }

    return (
        <>
        {data.details && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Withdrawal details</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
            <input 
            type="text"
            className="form-control w-100 py-1"
            value={data.method}
            readOnly
            />
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="1000" 
                    className="inputNone"
                    value={data.amount}
                    readOnly
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                {data.symbol}
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Details:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <textarea 
                placeholder={`Your bank payment details`}
                className="inputNone w-100 py-1"
                value={`${data.details.wallet}${data.details.skrilladdress}${data.details.paypaladdress}${data.details.paymentDetails}`}
                rows={4}
                readOnly
                />
            </div>
            <div className="myBtn w-100 text-center mt-3" style={{paddingTop: '12px', paddingBottom: '12px'}} onClick={() => setIsOpen(false)}>Hide details</div>
        </Modal>
        )}
        <tr className="fw-semibold">
            <td>#{data.hash}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data?.user?.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data?.user?.fullname}</span>
                </div>
            </td>
            <td>
                <div className='d-flex align-items-center'>
                    <span>{data.method.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>
                    {data.details && (
                        <div className="d-flex align-items-center justify-content-center rounded-2 ms-2" style={{width: '26px', height: '26px',backgroundColor:'#ffffff0d',cursor:'pointer'}} onClick={() => setIsOpen(true)}>
                            <FontAwesomeIcon icon={faEye} style={{fontSize: '12px'}} />
                        </div>
                    )}
                </div>
            </td>
            <td className='text-nowrap'><img src={data.logo} alt="Method" style={{width: '20px'}} /> <span className='ms-2 fw-bold text-nowrap'>{data.amount} {data.symbol}</span></td>
            <td className='text-nowrap'>{data.date}</td>
            <td
              style={{
                color:
                  data.status === 'pending'
                    ? 'orange'
                    : data.status === 'failed'
                    ? 'red'
                    : 'green',
              }}
            >
              {data.status === 'success'
                ? 'Approved'
                : data.status === 'failed'
                ? 'Declined'
                : data.status.charAt(0).toUpperCase() + data.status.slice(1)}
            </td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                >
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Approve(data.id)}>
                    Approve
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Decline(data.id)}>
                    Decline
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete(data.id)}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
        </>
    )
  }
  
  export default RowList2